import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Code, Smartphone, Figma, Gamepad2, Puzzle } from 'lucide-react';
import styles from './WebDesignContent.module.css';
import WebGraphicContent from '../WebGraphicContent/WebGraphicContent';
import portfolio1 from '../../images/portfolio-1.jpg';
import portfolio2 from '../../images/portfolio-2.jpg';
import portfolio3 from '../../images/grid-plugin.png';
import portfolio9 from '../../images/gallery-plugin.png'
import portfolio4 from '../../images/feedback.png';
import portfolio5 from '../../images/portfolio-14.jpg';
import portfolio6 from '../../images/portfolio-15.jpg';
import portfolio7 from '../../images/Nameplacething-Header.jpg';
import portfolio8 from '../../images/drawing-app-1.png';
import portfolio10 from '../../images/king-1.png';
import portfolio11 from '../../images/portfolio-3.jpg';


const WebDesignContent = ({ onModeChange }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('web');

  const categories = [
    { id: 'web', name: 'Web Design', icon: Code, color: '#06b6d4' },
    { id: 'plugins', name: 'Plugins', icon: Puzzle, color: '#10b981' },
    { id: 'flutter', name: 'Flutter', icon: Smartphone, color: '#3b82f6' },
    { id: 'figma', name: 'Figma', icon: Figma, color: '#a855f7' },
    { id: 'games', name: 'Games', icon: Gamepad2, color: '#f59e0b' }
  ];

  const projects = {
    web: [
      { id: 1, title: 'Web & Marketing', category: 'Wordpress', image: portfolio1, link: '/web-marketing' },
      { id: 2, title: 'ERP System', category: 'Wordpress', image: portfolio2, link: '/erp-system' },
      { id: 3, title: 'Ecommerce', category: 'Wordpress', image: portfolio11, link: '/ecommerce' },
    ],
    plugins: [
      { id: 14, title: 'Grid Plugin', category: 'WordPress Plugin', image: portfolio3, link: '/gridplugin' },
      { id: 15, title: 'Feedback Plugin', category: 'WordPress Plugin', image: portfolio4, link: '/feedbackplugin' },
      { id: 16, title: 'Masonry Gallery Plugin', category: 'WordPress Plugin', image: portfolio9, link: '/masonrygallery' },
    ],
    flutter: [
      { id: 7, title: 'Student Education App', category: 'Flutter & Firebase', image: portfolio4, link: '/flutter' },
    ],
    figma: [
      { id: 8, title: 'Farmsmojo Mobile App', category: 'Component Library', image: portfolio5, link: '/farmsmojo-app' },
      { id: 9, title: 'Amore Dating App', category: 'iOS & Android', image: portfolio6, link: '/dating-app' },
    ],
    games: [
      { id: 10, title: 'Name Place Animal Thing', category: 'Multiplayer Game', image: portfolio7, link: '/nameplacething' },
      { id: 12, title: 'Guess The Image', category: 'Multiplayer Drawing Game', image: portfolio8, link: '/guess-the-image' },
      { id: 13, title: 'KingsCourt', category: 'Multiplayer Card Game', image: portfolio10, link: '/kingscourt' },
    ]
  };

  const services = [
    { icon: '🎨', title: 'UI/UX Design', desc: 'Beautiful interfaces that users love' },
    { icon: '⚡', title: 'Performance', desc: 'Lightning-fast load times' },
    { icon: '📱', title: 'Responsive', desc: 'Perfect on all devices' },
    { icon: '🔒', title: 'Secure', desc: 'Built with security in mind' },
  ];

  const handleCardClick = (link) => {
    if (link === '/flutter' || link === '/nameplacething') {
      window.location.href = link;
    } else {
      window.location.href = link;
    }
  };

  return (
    <div>
      <section id="projects" className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Featured Projects</h2>
          <p className={styles.sectionSubtitle}>Explore my latest work across different platforms</p>
          
          {/* Accordion Tabs */}
          <div className={styles.tabContainer}>
            {categories.map((cat) => {
              const Icon = cat.icon;
              return (
                <button
                  key={cat.id}
                  onClick={() => setActiveTab(cat.id)}
                  className={`${styles.tab} ${activeTab === cat.id ? styles.tabActive : ''}`}
                  style={{
                    '--tab-color': cat.color
                  }}
                >
                  <Icon size={20} />
                  <span>{cat.name}</span>
                  <div className={styles.tabIndicator}></div>
                </button>
              );
            })}
          </div>

          {/* Project Cards */}
          <div className={styles.projectsWrapper}>
            {categories.map((cat) => (
              <div
                key={cat.id}
                className={`${styles.projectsGrid} ${activeTab === cat.id ? styles.projectsActive : ''}`}
              >
                {projects[cat.id].slice(0, 3).map((project, index) => (
                  <div
                    key={project.id}
                    className={`${styles.card} ${styles.cardWeb}`}
                    onClick={() => handleCardClick(project.link)}
                    style={{
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <div 
                      className={`${styles.cardImage} ${styles.cardImageWeb}`}
                      style={{ backgroundImage: `url(${project.image})` }}
                    >
                      <div className={styles.imageOverlay}></div>
                    </div>
                    <div className={`${styles.cardOverlay} ${styles.cardOverlayWeb}`}>
                      <span className={styles.overlayTitle}>{project.title}</span>
                      <span className={styles.overlayArrow}>→</span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          
          {/* View All Button */}
          <div className={styles.viewAllContainer}>
            <button 
              className={styles.viewAllButton}
              onClick={() => window.location.href = '/all-projects'}
            >
              View All Projects
            </button>
          </div>
        </div>
      </section>

      

      <section id="services" className={`${styles.section} ${styles.sectionDark}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>What I Offer</h2>
          <div className={`${styles.grid} ${styles.grid4}`}>
            {services.map((service, idx) => (
              <div key={idx} className={styles.serviceCard}>
                <div className={styles.serviceIcon}>{service.icon}</div>
                <h3 className={styles.serviceTitle}>{service.title}</h3>
                <p className={styles.serviceDesc}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WebGraphicContent onModeChange={onModeChange} />
      
      {/* Footer */}
      

      {/* Let's Create Together Section */}
      <section className={`${styles.section} ${styles.contactSection}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>Let's Create Together</h2>
          <p className={styles.contactText}>Ready to bring your vision to life</p>
          
          <div className={styles.skillsRow}>
            <a
              href={require('../../images/Pavithra Chandran.pdf')}
              download="Pavithra Chandran.pdf"
              className={`${styles.skillPill} ${styles.primaryPill}`}
              style={{ textDecoration: 'none' }}
            >
              <span className={styles.skillIcon}>📄</span>
              <span>Download CV</span>
            </a>
            <div 
              className={`${styles.skillPill} ${styles.primaryPill}`}
              onClick={() => navigate('/contact')}
            >
              <span className={styles.skillIcon}>✉️</span>
              <span>Get In Touch</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🎨</span>
              <span>CSS</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🌐</span>
              <span>HTML5</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>⚛️</span>
              <span>React</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>📱</span>
              <span>Flutter</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>💻</span>
              <span>JavaScript</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🎨</span>
              <span>Tailwind CSS</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>📝</span>
              <span>WordPress</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🅰️</span>
              <span>Angular</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🐍</span>
              <span>Python</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>☕</span>
              <span>Java</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🔷</span>
              <span>TypeScript</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🟢</span>
              <span>Node.js</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🍃</span>
              <span>MongoDB</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🐘</span>
              <span>PHP</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>💎</span>
              <span>Ruby</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🦀</span>
              <span>Rust</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🔵</span>
              <span>C++</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🟣</span>
              <span>C#</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🐹</span>
              <span>Go</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🦄</span>
              <span>Kotlin</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🍎</span>
              <span>Swift</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>🌐</span>
              <span>Web Design</span>
            </div>
            <div className={styles.skillPill}>
              <span className={styles.skillIcon}>💻</span>
              <span>Full Stack</span>
            </div>
          </div>
          <p className={styles.codefooter}>Crafted with creativity and passion ✨</p>
        </div>
      </section>
            
      
      
    </div>
  );
};

export default WebDesignContent;